import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=4376ea5a&scoped=true"
import script from "./Organizer.vue?vue&type=script&lang=js"
export * from "./Organizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4376ea5a",
  null
  
)

export default component.exports